import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  CHeader,
  CToggler,
  CSubheader,
  CBreadcrumbRouter,
  CRow,
  CFormGroup,
  CNavbarBrand,
  CHeaderNav
} from '@coreui/react';
import Select from 'react-select';
import { Container, Nav } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import useAuth from "../react-jwt-spa";

// routes config
import routes from '../routes';
// import { toast } from 'react-toastify';
// import fileServiceClient from 'src/services/Common/FileServiceClient';
import {
  TheHeaderDropdown
}  from './index';


const TheHeader = () => {
  const dispatch = useDispatch()
  const sidebarShow = useSelector(state => state.sidebarShow)
  const selectedYear = useSelector(state => state.selectedYear);
  const { isAuthenticated } = useAuth();

  const years = [];    
  for (let i = new Date().getFullYear() - 5; i <= new Date().getFullYear() + 1; i++) {
    years.push({ "value": i.toString(), "label": i.toString() });
  }   

  if (selectedYear === undefined || selectedYear === null) {
    dispatch({type: 'set', selectedYear: new Date().getFullYear().toString()})
  }

  const toggleSidebar = () => {
    const val = [true, 'responsive'].includes(sidebarShow) ? false : 'responsive'
    dispatch({type: 'set', sidebarShow: val})
  }

  const toggleSidebarMobile = () => {
    const val = [false, 'responsive'].includes(sidebarShow) ? true : 'responsive'
    dispatch({type: 'set', sidebarShow: val})
  }

  const setSelectedYear = (year) => {
    console.log("setSelectedYear", year.toString());
    dispatch({type: 'set', selectedYear: year.toString()})
  }

  return (
    <CHeader withSubheader>
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none"
        onClick={toggleSidebarMobile}
      />
      <CToggler
        inHeader
        className="ml-3 d-md-down-none"
        onClick={toggleSidebar}
      />


      <Navbar className="d-md-down-none mr-auto">
      <Container>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <CNavbarBrand href="#/dashboard" className={process.env.REACT_APP_BRAND_CSS}>{process.env.REACT_APP_TITLE}</CNavbarBrand>
            <Nav.Link href="#/facturas" hidden={!isAuthenticated}>Facturas</Nav.Link>                                           
            <Nav.Link href="#/otros-documentos" hidden={!isAuthenticated}>Modelo 347</Nav.Link>      
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>

      <CHeaderNav className="px-3 align-right">
        <TheHeaderDropdown/>
      </CHeaderNav> 

      <CSubheader className="px-3 justify-content-between">
        <CBreadcrumbRouter className="border-0 c-subheader-nav m-0 px-0 px-md-3" routes={routes} />
        <div className="mfe-2 c-subheader-nav">
            <CRow>
              <CFormGroup hidden={!isAuthenticated}>
                <Select 
                    name="year" 
                      id="year"
                      valid={true}
                      value={years ? years.find(option => option.value === selectedYear) : ''}
                      onChange={e => setSelectedYear(e.value)}
                      className="select-years"
                      options={years}>
                </Select>
              </CFormGroup>
            </CRow>
          </div>
      </CSubheader>
    </CHeader>
  )
}

export default TheHeader
